import React from 'react';
import { WithTranslation, withTranslation } from 'react-i18next';

import { InputSelect } from '@bluevalet/common-ui';

import { isErrorField } from '../utils';
import { Api } from '../../common/model';

interface Props {
  prefix: 'start' | 'end';
  name: string;
  label: string;
  sites: Array<Api.Site>;
  value: string | undefined;
  forceValidation?: boolean;
  onChange: (value: string) => void;
}

const Dropdown = ({
  t,
  prefix,
  name,
  label,
  sites,
  onChange,
  value = '',
  forceValidation = false,
}: Props & WithTranslation) => {
  const airports = sites.filter(({ type }) => type === 'airport');
  const stations = sites.filter(({ type }) => type === 'station');
  const selectedItem = sites.find(({ id }) => id === +(value || ''));

  const hasErrors = isErrorField(forceValidation, value);
  const inputProps = {
    'data-cy': `${prefix}-site`,
    disabled: false,
    success: false,
    error: hasErrors,
    message: hasErrors ? t('error-required') : '',
  };

  return (
    <InputSelect
      className="site-dropdown"
      id={`${prefix}-site`}
      name={name}
      label={label}
      value={value}
      title={selectedItem && selectedItem.name}
      onChange={onChange}
      placeholder={t('select')}
      {...inputProps}>
      {airports.length && (
        <optgroup label={t('site-type_airport')}>
          {airports.map(i => (
            <option key={i.id} value={i.id}>
              {i.name}
            </option>
          ))}
        </optgroup>
      )}
      {stations.length && (
        <optgroup label={t('site-type_station')}>
          {stations.map(i => (
            <option key={i.id} value={i.id}>
              {i.name}
            </option>
          ))}
        </optgroup>
      )}
    </InputSelect>
  );
};

export default withTranslation()(Dropdown);
